var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.topics)?_c('svg',{staticStyle:{"width":"100%","height":"200px"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }